import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

export interface ActivityType {
  isMeasurement: boolean;
  isInstallation: boolean;
  text: string;
  numberOfActivities: 'one' | 'many';
}

export interface UpdateActivityType extends ActivityType {
  activitiesUuid: string;
}

const useUpdateActivity = (
  options?: UseMutationOptions<any, Error, UpdateActivityType>
) => {
  return useMutation({
    ...options,
    mutationKey: ['updateActivity'],
    mutationFn: async (data) => {
      return axiosInstance.put(`/activity`, data).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Aktualizacja czynności...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'update-activity',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Czynność zaktualizowana pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'update-activity',
      });
      queryClient.invalidateQueries({ queryKey: ['userActivities'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji czynności.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'update-activity',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateActivity;
